// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_g-1";
export var movingGradient = "_g-4";
export var movingGradientBlock = "_g-2";
export var skeleton = "_g-0";
export var skeletonText = "_g-3";